import React from "react";

const BoldMark = (props) => {
    return (
        <strong>
            {props.children}
        </strong>
    );
}

export default BoldMark;